document.addEventListener('DOMContentLoaded', function() {
  // Function to show messages below the Add to Cart button
  function showMessage(message, isError = false) {
    var messageContainer = document.getElementById('message-container');
    messageContainer.textContent = message;
    messageContainer.className = isError ? 'error-message' : 'success-message';
    messageContainer.style.display = 'block';
  }

  // Function to format number as currency
  function formatAsCurrency(number) {
  return new Intl.NumberFormat(navigator.language, { style: 'currency', currency: 'USD' }).format(number);
  }


  // Event listeners for increment and decrement buttons
  document.querySelectorAll('.variant-row').forEach(row => {
    const incrementButton = row.querySelector('.increment-btn');
    const decrementButton = row.querySelector('.decrement-btn');
    const quantityInput = row.querySelector('.quantity-input');

    incrementButton.addEventListener('click', function() {
      quantityInput.value = parseInt(quantityInput.value, 10) + 1;
      updateTotalPrice(row);
    });

    decrementButton.addEventListener('click', function() {
      quantityInput.value = Math.max(0, parseInt(quantityInput.value, 10) - 1);
      updateTotalPrice(row);
    });
  });

  // Function to update total price for each variant row
  function updateTotalPrice(row) {
    const priceElement = row.querySelector('.variant-price');
    const price = parseFloat(priceElement.textContent.replace(/[^\d.]/g, ''));
    const quantity = parseInt(row.querySelector('.quantity-input').value, 10) || 0;
    const totalPriceElement = row.querySelector('.variant-total-price');
    totalPriceElement.textContent = formatAsCurrency(price * quantity);
  }

  // Add to Cart event
  document.getElementById('add-to-cart-button').addEventListener('click', function() {
    let itemsToAdd = [];

    // Collect all variant quantities and ids
    document.querySelectorAll('.variant-row').forEach(function(row) {
      const variantId = row.getAttribute('data-variant-id');
      const quantity = parseInt(row.querySelector('.quantity-input').value, 10);

      if (quantity > 0) {
        itemsToAdd.push({ id: variantId, quantity: quantity });
      }
    });

    if (itemsToAdd.length > 0) {
      addItemsToCart(itemsToAdd);
    } else {
      showMessage('Please select at least one item to add to your cart.', true);
    }
  });

  // Function to add items to cart
  function addItemsToCart(items) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: items })
    })
    .then(function(response) {
      if (!response.ok) throw new Error('HTTP error, status = ' + response.status);
      return response.json();
    })
    .then(function(cart) {
      showMessage('Items added to cart!');
      // Optionally redirect to the cart page
      // window.location.href = '/cart';
    })
    .catch(function(error) {
      console.error('Error:', error);
      showMessage('Error adding items to cart.', true);
    });
  }
});
